
window.chartInterop = {

    initializeChart: (canvasId, config) =>
    {
        config = cleanConfig(config);
        parseCallbacks(config.options);

        const ctx = document.getElementById(canvasId).getContext('2d');

        if (!config.data || !config.data.datasets || config.data.datasets.length === 0 || config.data.datasets[0].data.length === 0 || config.data.datasets[0].data.every(value => value === 0))
        {
            config = createDefaultGrayChartConfig(config, canvasId);
            config.options.plugins.tooltip.enabled = false;

        }
        else
        {

            if (canvasId != "past_years_line")
            {
                const patterns = drawPatterns(config.data);
                config.data.datasets[0].backgroundColor = patterns;
                applyPatternsToCircleIndicators(patterns, canvasId);

                //const originalDoughnutController = Chart.controllers.doughnut;
                //Chart.controllers.doughnut = class extends originalDoughnutController
                //{
                //    draw()
                //    {
                //        let ctx = this.chart.ctx;
                //        ctx.save();
                //        ctx.shadowColor = '#000000';
                //        ctx.shadowBlur = 1;
                //        ctx.shadowOffsetX = 0;
                //        ctx.shadowOffsetY = 1;
                //        super.draw();
                //        ctx.restore();
                //    }
                //};

            }

            if (canvasId == "past_years_line")
            {
                config.options.plugins.legend.onHover = function (event, legendItem, legend)
                {
                    var options = this.options || {};
                    var hoverOptions = options.hover || {};
                    var ci = this.chart;
                    hoveredDatasetIndex = legendItem.datasetIndex;
                    var activeElements = [];

                    //restore original border width
                    ci.config.data.datasets.forEach((dataset, index) =>
                    {
                        dataset.borderWidth[0] = 2;
                        dataset.borderColor[0] = dataset.pointBorderColor;

                    });

                    ci.config.data.datasets[hoveredDatasetIndex].borderWidth[0] = 4;
                    ci.config.data.datasets[hoveredDatasetIndex].borderColor[0] = ci.config.data.datasets[hoveredDatasetIndex].pointHoverBorderColor;
                    ci.config.data.datasets[hoveredDatasetIndex].data.forEach((dataItem, index) =>
                    {
                        var element = { datasetIndex: hoveredDatasetIndex, index: index };
                    
                        activeElements.push(element);

                    });
                    ci.setActiveElements(activeElements);
                    ci.render();
                    ci.update();
                }

                const originalLineController = Chart.controllers.line;
                Chart.controllers.line = class extends originalLineController
                {
                    draw()
                    {
                        let ctx = this.chart.ctx;
                        ctx.save();
                        ctx.shadowColor = '#000000';
                        ctx.shadowBlur = 2;
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 1;
                        super.draw();
                        ctx.restore();
                    }
                };

                // Store the original controller for cleanup
                window.originalLineController = originalLineController;

                // Apply dashed line style to the dataset with label "All Student Group"
                config.data.datasets.forEach(dataset =>
                {
                    if (dataset.label === "All Student Group")
                    {
                        dataset.borderDash = [5, 5]; // Dash pattern: 5px dash, 5px gap
                    }
                });
            }
        }

        const chart = new Chart(ctx, config);

        window.myCharts = window.myCharts || {};
        window.myCharts[canvasId] = chart;

        return chart;
    },

    destroyChart: function (canvasId)
    {
        if (window.myCharts && window.myCharts[canvasId])
        {
            window.myCharts[canvasId].destroy();
            delete window.myCharts[canvasId];
        }
    },

    updateChart: (chartRef, newData, newOptions) =>
    {

        const chart = chartRef;
        if (chart)
        {
            if (newData)
            {

                if (chartRef.canvas.id != "past_years_line")
                {
                    const patterns = drawPatterns(newData);
                    newData.datasets[0].backgroundColor = patterns;
                }

                chart.data = newData;

            }

            if (newOptions)
            {
                chart.config.options = newOptions;
                chart.config = cleanConfig(chart.config);
                parseCallbacks(chart.config.options);

                // Apply dashed line style to the dataset with label "All Student Group"
                chart.config.data.datasets.forEach(dataset =>
                {
                    if (dataset.label === "All Student Group")
                    {
                        dataset.borderDash = [5, 5]; // Dash pattern: 5px dash, 5px gap
                    }
                });

            }

            if (!chart.config.data || !chart.config.data.datasets || chart.config.data.datasets.length === 0 || chart.config.data.datasets[0].data.length === 0 || chart.config.data.datasets[0].data.every(value => value === 0))
            {
                chart.config = createDefaultGrayChartConfig(chart.config, chartRef.canvas.id);
                chart.config.options.plugins.tooltip.enabled = false;
            }

            chart.update();


        }
    },
    
    clearActiveElement: (chartRef) => {
        const chart = chartRef;
        chart.setActiveElements([]);
        chart.tooltip.setActiveElements([]);
        chart.update();
    },

    setActiveElement: (chartRef, datasetIndex, index) => {
        const chart = chartRef;
        if (chart && chart.data && chart.data.datasets && chart.data.datasets.length > 0 && chart.data.datasets[0].data.length > 1)
        {
            chart.setActiveElements([{ datasetIndex: datasetIndex, index: index }]);
            chart.tooltip.setActiveElements([{ datasetIndex: datasetIndex, index: index }]);
            chart.update();

            setTimeout(() =>
            {
                const activeElements = chartRef.getActiveElements();

                if (activeElements.length > 0)
                {
                    const activeElement = activeElements[0];
                    const activeDatasetIndex = activeElement.datasetIndex;
                    const activeIndex = activeElement.index;

                    if (activeDatasetIndex === datasetIndex && activeIndex === index)
                    {
                        chart.setActiveElements([]);
                        chart.tooltip.setActiveElements([]);
                        chart.update();
                    }
                }
            }, 2000);
        } else
        {
            console.warn("No data in the chart to set active element.");
        }
    },

    setActiveDataset: (chartRef, datasetIndex) =>
    {
        const chart = chartRef;

        if (chart)
        {
            // Validate dataset index
            if (datasetIndex < 0 || datasetIndex >= chart.data.datasets.length)
            {
                console.error("Invalid dataset index:", datasetIndex);
                return;
            }

            const datasetElements = chart.getDatasetMeta(datasetIndex).data;

            if (!datasetElements || datasetElements.length === 0)
            {
                console.warn(`No elements found for dataset index: ${datasetIndex}`);
                return;
            }

            const activeElements = datasetElements.map((_, index) => ({
                datasetIndex: datasetIndex,
                index: index,
            }));

            chart.setActiveElements(activeElements);

            chart.update();
        } else
        {
            console.error("Chart reference is not valid.");
        }
    },

    downloadChartImage: (canvasId) =>
    {
        const canvas = document.getElementById(canvasId);
        if (canvas)
        {
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = 'chart-image.png';
            link.click();
        } else
        {
            console.error(`Canvas with ID ${canvasId} not found.`);
        }
    },

    yAxisPercentageFormatter: function (value)
    {
        return value + "%"; // Format y-axis tick values as percentages
    },

    tooltipPercentageFormatter: function (context)
    {
        //return context.raw !== undefined ? context.raw + "%" : ""; // Format tooltip values as percentages
        if (context && context.raw !== undefined && context.dataset.label === "")
        {
            return `${context.raw}%`;
        }
        else if (context && context.raw !== undefined)
        {
            return `${context.dataset.label}
            ${context.raw}%`;
        }
        else
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }
    },

    tooltipDollarFormatter: function (context)
    {
        if (context && context.raw !== undefined)
        {
            const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0
            }).format(context.raw);

            if (context.dataset.label === "")
            {
                return `${formattedValue}`;
            } else
            {
                return `${context.dataset.label} ${formattedValue}`;
            }
        } else
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }
    },

    
};

function createDefaultGrayChartConfig(config, canvasId)
{
    config.data = {
        labels: ['No Data'],
        datasets: [{
            label: 'No Data',
            data: [1],
            backgroundColor: ['gray'],
            borderColor: 'gray',
            borderWidth: 1
        }]
    };

    const patterns = drawPatterns(config.data);
    config.data.datasets[0].backgroundColor = patterns;
    applyPatternsToCircleIndicators(patterns, canvasId);

    return config;

}

function cleanConfig(config)
{
    // Remove null values from the config object
    if (typeof config === 'object' && config !== null)
    {
        for (const key in config)
        {
            if (config[key] === null)
            {
                delete config[key];
            } else if (typeof config[key] === 'object')
            {
                cleanConfig(config[key]); // Recursively clean nested objects
            }
        }
    }
    return config;
}

function parseCallbacks(options)
{
    for (const key in options)
    {
        if (options.hasOwnProperty(key))
        {
            const value = options[key];

            // Process only properties named 'callback' (case-insensitive)
            if (typeof value === 'string' && value.includes('.'))
            {
                const parts = value.split('.');
                let func = window;

                for (const part of parts)
                {
                    func = func[part];
                    if (!func) break;
                }

                if (typeof func === 'function')
                {
                    options[key] = func;
                }
            }

            // Recursively parse nested objects
            if (typeof value === 'object' && value !== null)
            {
                parseCallbacks(value);
            }
        }
    }
}

function darkenColor(color, amount = 20)
{
    
    if (Array.isArray(color))
    {
        color = color[0];
    }

    const colorParts = color.match(/\d+/g).map(Number);
    const [r, g, b] = colorParts;
    return `rgb(${Math.max(0, r - amount)}, ${Math.max(0, g - amount)}, ${Math.max(0, b - amount)})`;
}

function ColorLuminance(hex, lum)
{

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6)
    {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++)
    {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }

    return rgb;
}

function drawPatterns(configData) {

    if (!configData.datasets || configData.datasets.length === 0 || configData.datasets[0].backgroundColor.length === 0) {
        return null;
    }

    var backgroundColors = configData.datasets[0].backgroundColor;

    if (backgroundColors.some(color => !color.includes(',')))
    {
        return pattern.draw('circle', 'gray');
    }

    //using patternomaly
    var patterns = backgroundColors.map(function (item) {
        var parts = item.split(','); // Split "pattern,color" string
        var patternType = parts[0].trim();
        var color = parts[1].trim();
        return pattern.draw(patternType, color);
    });

    ////using patternomaly
    //var patterns = [
    //    pattern.draw('square', '#1f77b4'),
    //    pattern.draw('circle', '#ff7f0e'),
    //    pattern.draw('diamond', '#2ca02c'),
    //    pattern.draw('zigzag-horizontal', '#17becf'),
    //    pattern.draw('triangle', 'rgb(255, 99, 132, 0.4)') // with opacity
    //];

    return patterns;
}

function applyPatternsToCircleIndicators(patternArray, canvasId) {
    if (patternArray == null || patternArray.length === 0) {
        return;
    }

    var classNames = [];

    if (canvasId == "enrollment_race_doughnut")
    {
        classNames = ['asian',
            'black',
            'hispanic',
            'american-indian',
            'hawaiian',
            'multiracial',
            'white',
            'federal',
            'statelocal'
        ];
    }
    else if (canvasId.includes("per-pupil"))
    {
        classNames = ['statelocal',
            'federal'
        ];
    }

    document.querySelectorAll('.chart-color-indicator').forEach((element) => {
        const className = classNames.find(cls => element.classList.contains(cls));
        const pattern = patternArray[classNames.indexOf(className)];

        if (className && pattern) {
            // Create a temporary canvas to render the pattern
            const canvas = document.createElement('canvas');
            canvas.width = 30; // Match the indicator size
            canvas.height = 30;

            const ctx = canvas.getContext('2d');
            ctx.fillStyle = pattern; // Set the CanvasPattern as fillStyle
            ctx.fillRect(0, 0, canvas.width, canvas.height); // Fill the canvas

            // Convert the canvas to a data URL and apply it as background-image
            element.style.backgroundImage = `url(${canvas.toDataURL()})`;
        }
    });

}
